import React, {useState} from 'react';
import {TaskData} from '../../../../types/TaskData';
import './ConstructionOrder.css';
import ConstructionOrderTable from "../constructionOrderTable/ConstructionOrderTable";
import ConstructionOrderCreation from "../constructionOrderCreation/ConstructionOrderCreation";
import {ViewType} from "../../../../types/ViewType";

const ConstructionOrder: React.FC = () => {
    const [selectedRows, setSelectedRows] = useState<TaskData[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleRowSelect = (rows: TaskData[]) => {
        setSelectedRows(rows);
    };

    const onRefreshTable = () => {
        setSelectedRows([]);
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="measure-order-container">
            <div className="table-container-construction">
                <ConstructionOrderTable onSelectRows={handleRowSelect} refreshKey={refreshKey} />
            </div>
            <div className="detail-container-construction">
                {selectedRows.length > 0 && (
                    <ConstructionOrderCreation key={selectedRows.map(row => row.id).join('-')} data={selectedRows} onRefreshTable={onRefreshTable} viewType={ViewType.NEW} />
                )}
            </div>
        </div>
    );
};

export default ConstructionOrder;
